module.exports = __webpack_public_path__ + "static/media/sql.c57ae131.svg";